/* Home: the hero film's pause button and the header change on scroll. */
(() => {
'use strict';
if (!window.BotanifolSite) return;
window.BotanifolSite.mount(() => {
const S = window.BotanifolSite, film = document.getElementById('campaign-film'), toggle = document.getElementById('film-toggle'), hero = document.querySelector('.editorial-hero');
if (!S || !film || !hero) return;
if (!S.Video.controllable(film)) toggle.hidden = true;
else {
  const sync = () => {
    const paused = S.Video.paused(film);
    toggle.textContent = paused ? '▷' : 'Ⅱ';
    toggle.setAttribute('aria-label', paused ? 'Play homepage film' : 'Pause homepage film');
    toggle.setAttribute('aria-pressed', String(!paused));
  };
  toggle.addEventListener('click', () => S.userToggle(film));
  S.Video.on(film, sync); sync();
}
const syncScroll = () => hero.classList.toggle('hero-introduced', window.scrollY > 45);
window.addEventListener('scroll', syncScroll, { passive: true });
window.addEventListener('pageshow', syncScroll);
syncScroll();
});
})();
